// component entry file
// eslint-disable-next-line import/extensions
import HypoVueBaseMixin from './hypo-vue-base-mixin.js';

export default HypoVueBaseMixin;
